import { ApiUtility } from "../Utilities/ApiUtility.axios";

class UserService {
  route = `/Api/AMLReport`;

  getAMLReport = (
    practiceId: number = 0,
    start: number,
    length: any,
    search: string,
    fromDate: string,
    toDate: string,
    sortCol: any,
    sortDir: any,
  ) =>
    ApiUtility.get(`${this.route}`, {
      practiceId,
      start,
      length,
      search,
      fromDate,
      toDate,
      sortDir,
      sortCol,
    });

  getAMLStatsDownload = (
    practiceId: number,
    search: string = "",
    fromDate?: string,
    toDate?: string,
    sortCol?: string,
    sortDir?: string,
  ) => {
    return ApiUtility.downloadFile(`${this.route}`, {
      practiceId,
      search,
      fromDate,
      toDate,
      sortCol,
      sortDir,
      isDownload: true,
    });
  };
}
export default new UserService();
